<template>
  <span>
    <span>{{ displayText }}</span>
    <slot />
  </span>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'

const props = defineProps({
  words: { type: Array, required: true },
  typingSpeed: { type: Number, default: 80 },
  deletingSpeed: { type: Number, default: 40 },
  delay: { type: Number, default: 1200 },
})

const displayText = ref('')
const showCursor = ref(true)
let wordIndex = 0
let charIndex = 0
let isDeleting = false
let timeoutId = null

function type() {
  const currentWord = props.words[wordIndex]
  if (!isDeleting) {
    displayText.value = currentWord.slice(0, charIndex + 1)
    charIndex++
    if (charIndex === currentWord.length) {
      isDeleting = true
      timeoutId = setTimeout(type, props.delay)
      return
    }
    timeoutId = setTimeout(type, props.typingSpeed)
  } else {
    displayText.value = currentWord.slice(0, charIndex - 1)
    charIndex--
    if (charIndex === 0) {
      isDeleting = false
      wordIndex = (wordIndex + 1) % props.words.length
      timeoutId = setTimeout(type, props.typingSpeed)
      return
    }
    timeoutId = setTimeout(type, props.deletingSpeed)
  }
}

onMounted(() => {
  type()
  // Cursor blink
  const cursorInterval = setInterval(() => {
    showCursor.value = !showCursor.value
  }, 500)
  onUnmounted(() => {
    clearTimeout(timeoutId)
    clearInterval(cursorInterval)
  })
})
</script>

<style scoped>
.animate-blink {
  animation: blink 1s steps(1) infinite;
  /* width: 1ch; display: inline-block;  // handled inline for specificity */
}
@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}
</style> 